module.exports = __webpack_public_path__ + "static/media/bg9.bc9d2197.jpg";